import loadable from '@loadable/component'

export const RatingsCriteriaReport = loadable(
  () => import('./RatingsCriteriaReport')
)
export const RatingsCriteriaReportListing = loadable(
  () => import('./RatingsCriteriaReportListing')
)
export type {
  RatingsCriteriaReportRenderLinkProps,
  RatingsCriteriaReportProps
} from './RatingsCriteriaReport'
export type { RatingsCriteriaReportListingProps } from './RatingsCriteriaReportListing'
